var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"version"},[_vm._v(" "+_vm._s(_vm.config.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }